import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
const headlines = ['Cómo rescatar la voluntad de tu hijo antes de que el algoritmo de TikTok la borre para siempre.', 'Tu hijo de 10 años tiene el cerebro de un adicto al casino. Aquí está el protocolo para recuperarlo.', "ENFOQUE DE ACERO: El sistema de 21 días para niños que 'no hacen caso' y solo viven para la pantalla.", 'Padres en USA: Dejen de pelear por el iPad. Empiecen a entrenar un Líder de Élite.', "Por qué los castigos fallan y por qué el 'Re-cableado de Dopamina' es la única solución.", "El fin del 'Cerebro Zombi': Cómo devolverle el asombro y la disciplina a tu hijo de 9-22 años.", 'Lo que Silicon Valley no quiere que sepas sobre el cerebro de tus hijos (y cómo protegerlos).', "Transforma a tu 'niño difícil' en un operador enfocado en solo 3 semanas.", 'El método Navy SEAL adaptado para la disciplina de la Generación Alpha.', '¿Irritable? ¿Distraído? ¿Sin hobbies? Tu hijo necesita un Detox de Dopamina Inmediato.', 'Blindaje Mental: El protocolo definitivo para padres latinos en un mundo digital.', 'De la apatía a la acción: El mapa de 21 días que los colegios no te enseñan.'];
const urgencyPoints = [{
  emoji: '⚡',
  text: 'Cada semana sin entrenamiento = 168 horas más de condicionamiento algorítmico'
}, {
  emoji: '🧠',
  text: 'El cerebro adolescente es 2x más susceptible a la adicción digital que el adulto'
}, {
  emoji: '🎯',
  text: "El 73% de los padres que esperan 'el momento perfecto' nunca actúan"
}, {
  emoji: '🏆',
  text: 'Los líderes de la próxima generación ya están entrenando su enfoque — ¿y tu hijo?'
}];
export function UrgencySection() {
  const marqueeRef = useRef<HTMLDivElement>(null);
  return <section className="py-20 bg-[#0F172A] text-white overflow-hidden relative" data-id="element-183">
      {/* Subtle grid texture */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
      backgroundSize: '40px 40px'
    }} data-id="element-184" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 mb-12" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-186">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#F97316]/20 text-[#F97316] text-sm font-bold uppercase tracking-wider mb-6" data-id="element-187">
            <Zap className="h-4 w-4" data-id="element-188" />
            Por Qué Actuar Ahora
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white uppercase" data-id="element-189">
            El Algoritmo No Descansa.{' '}
            <span className="text-[#F97316]" data-id="element-190">Tú Tampoco Deberías.</span>
          </h2>
        </motion.div>

        {/* Urgency Points */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl mx-auto mb-16" data-id="element-191">
          {urgencyPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white/5 border border-white/10 rounded-xl p-5" data-id="element-192">
              <span className="text-2xl flex-shrink-0" data-id="element-193">{point.emoji}</span>
              <p className="text-slate-300 font-medium leading-snug" data-id="element-194">
                {point.text}
              </p>
            </motion.div>)}
        </div>
      </div>

      {/* Scrolling Headlines Marquee */}
      <div className="relative w-full overflow-hidden py-4" data-id="element-195">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-[#0F172A] to-transparent z-10 pointer-events-none" data-id="element-196" />
        <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-[#0F172A] to-transparent z-10 pointer-events-none" data-id="element-197" />

        <motion.div className="flex gap-8 whitespace-nowrap" animate={{
        x: ['0%', '-50%']
      }} transition={{
        duration: 40,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-198">
          {/* Duplicate for seamless loop */}
          {[...headlines, ...headlines].map((headline, index) => <div key={index} className="inline-flex items-center gap-3 flex-shrink-0" data-id="element-199">
              <span className="text-[#F97316] font-bold text-lg" data-id="element-200">⚡</span>
              <span className="text-slate-300 text-base font-medium max-w-sm whitespace-normal inline-block align-middle" style={{
            maxWidth: '320px'
          }} data-id="element-201">
                {headline}
              </span>
              <span className="text-[#1B3A6B] mx-4 text-2xl font-bold" data-id="element-202">·</span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}